import styled from 'styled-components';

export const TagTypeContainer = styled.div`
  display: flex;
  gap: 15px;
`;

export const DividerContainer = styled.div`
  padding: 0 20px;
`;

export const TagTypeFooter = styled.div`
  padding: 20px;
  display: flex;
  justify-content: space-between;
`;
